import React, { useEffect, useState } from 'react'
import Balloon from './Balloon'
import unicodeToGsm from '../../../../libs/unicodeToGsm'
import { InformationCircleIcon } from '@heroicons/react/20/solid'
import { Tooltip } from 'antd'
import i18n from '../../../../i18n'
import { parseTextToHTML } from '../../../../libs/parse'
import { TEXT_TYPE } from './constants'

const NewSmsForm = ({
  setSender,
  sender,
  setMobileMessages,
  setSmsList,
  smsList,
  setErrors,
  errors,
  errorText,
  templateSMS
}) => {
  const [newSMS, setnewSMS] = useState(smsList)
  const [codificationSMS, setCodificationSMS] = useState({
    codification: '7bits',
    size: 0,
    limit: 160,
    SMS: 1
  })
  const [estado, setEstado] = useState(true)
  const [existVariables, setExistVariables] = useState(false)

  const [alert, setAlert] = useState()

  const typeEncondig = (e) => {
    //metodo para saber el tipo de codificación y el numero de caracteres utilizado y la cantidad de SMS
    let message = e.target.value
    setnewSMS(message)
    const regex = /{([^}]*)}/g
    const matches = e.target.value
      .match(regex)
      ?.map((match) => match.replace(regex, '$1'))
    setErrors((oldErrors) => {
      oldErrors.emptySms = false
      oldErrors.invalidVariable = false
      if (message === '') {
        oldErrors.emptySms = true
      } else {
        oldErrors.emptySms = false
        if (matches && matches.includes('')) {
          oldErrors.invalidVariable = true
        }
      }
      return oldErrors
    })
    setExistVariables(matches ? true : false)
    message = message.trim()
    const messageClean = message.replace(regex, '')
    const sevenBitencoding =
      '|	^	€	{	}	[	]	~ @ Δ SP 0 ¡ P ¿ p £ _ ! 1 A Q a q $ Φ " 2 B R b r ¥ Γ # 3 C S c s è Λ ¤ 4 D T d t é Ω % 5 E U e u ù Π & 6 F V f v ì Ψ \' 7 G W g w ò Σ ( 8 H X h x Ç Θ ) 9 I Y i y LF Ξ * : J Z j z Ø ESC + ; K Ä k ä ø Æ , < L Ö l ö CR æ - = M Ñ m ñ Å ß . > N Ü n ü å É / ? O § o à'
    const specialCharacter = '|	^	€	{	}	[	]	~'
    let contOfSpecialCharacter = 0
    sevenBitencoding.split()
    specialCharacter.split()

    let nEstado = true
    for (var i = 0; i < message.length; i++) {
      if (!unicodeToGsm[message.charCodeAt(i)]) {
        nEstado = false
        break
      }
      // if (specialCharacter.includes(message[i]))
      //     contOfSpecialCharacter = 1 + contOfSpecialCharacter
    }
    setEstado(nEstado)
    let smsCount
    let limit
    let ucsLimit
    if (nEstado) {
      let suma = contOfSpecialCharacter + messageClean.length
      limit = 160
      // adding header space
      if (suma > limit) {
        limit = 153
      }
      smsCount = clacularSMS(limit, suma)
      setCodificationSMS({
        codification: '7bits',
        size: suma,
        limit: limit,
        SMS: smsCount
      })
    } else {
      limit = 70
      if (messageClean.length > limit) {
        limit = 67
      }
      smsCount = clacularSMS(limit, messageClean.length)
      setCodificationSMS({
        codification: 'Unicode',
        size: messageClean.length,
        limit: limit,
        SMS: smsCount
      })
    }
    let messagesText = []
    let from = 0
    if (message.length > 0) {
      setMobileMessages([
        {
          type: TEXT_TYPE,
          text: message
        }
      ])
      messagesText.push(message.substring(from, message.length + 1))
    } else {
      setMobileMessages([])
    }

    // setSmsList(messagesText)
    setSmsList(message)
  }
  const clacularSMS = (limit, size) => {
    if (size == 0) return 1
    if (size > limit) {
    }
    const tam = Math.ceil(size / limit)
    if (tam > 1) setAlert(true)
    else setAlert(false)
    return tam
  }

  useEffect(() => {
    if (templateSMS) {
      typeEncondig({
        target: {
          value: templateSMS
        }
      })
    }
    if (newSMS !== '') {
      setMobileMessages([
        {
          type: TEXT_TYPE,
          text: newSMS
        }
      ])
    }
  }, [])

  return (
    <div className="w-full max-w-2xl space-y-6">
      {/* Sender Field */}
      <div className="bg-white rounded-2xl border-2 border-gray-100 p-5 hover:border-gray-200 transition-colors">
        <div className="flex items-center gap-2 mb-3">
          <label
            htmlFor="sender"
            className="text-xs font-semibold text-gray-500 uppercase tracking-wide"
          >
            {i18n.t('sender')}
          </label>
          <Tooltip
            placement="right"
            title={i18n.t('sender_validations')}
          >
            <InformationCircleIcon className="h-4 w-4 text-gray-400 hover:text-indigo-500 cursor-help transition-colors" />
          </Tooltip>
        </div>
        <input
          type="text"
          name="sender"
          id="sender"
          className={`block w-full max-w-xs text-base font-medium rounded-xl px-4 py-3 transition-all ${
            errors.invalidSender || errors.emptySender
              ? 'bg-red-50 text-gray-900 border-2 border-red-300 focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-200'
              : 'bg-gray-50 text-gray-900 border-2 border-gray-200 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 hover:border-gray-300'
          }`}
          placeholder={i18n.t('sender')}
          value={sender}
          onChange={(e) => {
            setSender(e.target.value)
            if (e.target.value === '') {
              setErrors((oldErrors) => {
                oldErrors.invalidSender = false
                oldErrors.emptySender = true
                return oldErrors
              })
            }
            const regex = /^([a-zA-Z0-9!:;+.-]{1,11}|[0-9]{10,16})$/
            if (!regex.test(e.target.value)) {
              setErrors((oldErrors) => {
                oldErrors.invalidSender = true
                oldErrors.emptySender = false
                return oldErrors
              })
            } else {
              setErrors((oldErrors) => {
                oldErrors.invalidSender = false
                oldErrors.emptySender = false
                return oldErrors
              })
            }
          }}
        />
        {errors.invalidSender && (
          <p className="text-red-500 text-xs mt-2 font-medium">{errorText.invalidSender}</p>
        )}
        {errors.emptySender && (
          <p className="text-red-500 text-xs mt-2 font-medium">{errorText.emptySender}</p>
        )}
      </div>

      {/* Message Text Field */}
      <div className="bg-white rounded-2xl border-2 border-gray-100 p-5 hover:border-gray-200 transition-colors">
        <div className="flex items-center gap-2 mb-3">
          <label
            htmlFor="msgText"
            className="text-xs font-semibold text-gray-500 uppercase tracking-wide"
          >
            {i18n.t('message_text')}
          </label>
          <Tooltip
            placement="right"
            title={i18n.t('to_add_variables')}
          >
            <InformationCircleIcon className="h-4 w-4 text-gray-400 hover:text-indigo-500 cursor-help transition-colors" />
          </Tooltip>
        </div>
        <textarea
          style={{ whiteSpace: 'pre-wrap' }}
          name="msgText"
          id="msgText"
          rows={5}
          className={`block w-full text-base rounded-xl px-4 py-3 resize-y transition-all ${
            errors.emptySms || errors.invalidVariable
              ? 'bg-red-50 text-gray-900 border-2 border-red-300 focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-200'
              : 'bg-gray-50 text-gray-900 border-2 border-gray-200 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 hover:border-gray-300'
          }`}
          placeholder={i18n.t('text')}
          value={newSMS}
          onChange={typeEncondig}
        />
        {errors.invalidVariable && (
          <p className="text-red-500 text-xs mt-2 font-medium">
            {errorText.invalidVariable}
          </p>
        )}
        {errors.emptySms && (
          <p className="text-red-500 text-xs mt-2 font-medium">{errorText.emptySms}</p>
        )}

        {/* Stats Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
          <div className="bg-gray-50 rounded-xl px-4 py-3">
            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">
              {i18n.t('characters_used').replace(':', '')}
            </p>
            <p className="text-lg font-bold text-gray-800">{codificationSMS.size}</p>
          </div>
          <div className="bg-gray-50 rounded-xl px-4 py-3">
            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">
              {i18n.t('codification_type').replace(':', '')}
            </p>
            <p className={`text-lg font-bold ${estado ? 'text-green-600' : 'text-amber-600'}`}>
              {estado ? 'GSM' : 'UNICODE'}
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl px-4 py-3">
            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">
              {i18n.t('available_chars').replace(':', '')}
            </p>
            <p className="text-lg font-bold text-gray-800">{codificationSMS.limit}</p>
          </div>
          <div className="bg-gray-50 rounded-xl px-4 py-3">
            <div className="flex items-center gap-1">
              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">
                {i18n.t('number_of_sms').replace(':', '')}
              </p>
              {existVariables && (
                <Tooltip
                  placement="top"
                  title={i18n.t('sms_could_increase')}
                >
                  <InformationCircleIcon className="h-3.5 w-3.5 text-amber-500 cursor-help" />
                </Tooltip>
              )}
            </div>
            <p className={`text-lg font-bold ${codificationSMS.SMS > 1 ? 'text-amber-600' : 'text-gray-800'}`}>
              {codificationSMS.SMS}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewSmsForm
